module.exports = __webpack_public_path__ + "media/images/sales/nanairoweek/point-2-summer-7042e79063f1c0a1150f401a3bf97f0a.jpg";